import React from "react";
// import {Nav} from "../navbar/nav";
import Footer from "../footer/footer";
import { Outlet } from "react-router-dom";
export default function Mainlayout() {
  return (
    <div className="">
      
      <main className="min-h-screen " >
        <Outlet />
      </main>
      <footer>
        <Footer />
      </footer>
    </div>
  );
}
